<div class="header">
  <div class="title">
    <p class="label">{{title()}}</p>
  </div>
</div>
